<div class="actionwrapper">
    <div class="actions">
        <button
            mat-raised-button
            color="primary"
            [disabled]="campaignCount === 0 && groups.length === 0"
            (click)="add()"
        >
            <mat-icon>add</mat-icon>
            Add New Campaign
        </button>
    </div>
</div>
<table class="table" mat-table matSort [dataSource]="tableDataSource">
    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td class="cell" mat-cell *matCellDef="let item">{{ item.name }}</td>
    </ng-container>
    <ng-container matColumnDef="channel">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Channel</th>
        <td class="cell" mat-cell *matCellDef="let item">Email</td>
    </ng-container>
    <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td class="cell" mat-cell *matCellDef="let item">{{ utilsService.capitalize(item.status) }}</td>
    </ng-container>
    <ng-container matColumnDef="groupNames">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Groups</th>
        <td class="cell" mat-cell *matCellDef="let item">{{ item.groupNames }}</td>
    </ng-container>
    <ng-container matColumnDef="actionmenu" stickyEnd>
        <th mat-header-cell matTooltip="Actions" *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item">
            <button mat-button class="cell" [matMenuTriggerFor]="menu" [matMenuTriggerData]="{ item: item }">
                <mat-icon matTooltip="Actions" class="more">more_vert</mat-icon>
            </button>
        </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
    <tr class="listitem" mat-row *matRowDef="let rows; columns: columnNames"></tr>
    <mat-menu #menu="matMenu">
        <ng-template matMenuContent let-item="item">
            <button mat-menu-item [disabled]="item.status !== 'created'" (click)="play(item)">Run</button>
            <button mat-menu-item (click)="edit(item)">Edit</button>
            <!-- <button mat-menu-item (click)="remove(item)">Delete</button> -->
            <button mat-menu-item (click)="clone(item)">Clone</button>
        </ng-template>
    </mat-menu>
</table>
